<template>
  <span class="mb-0">
      <i18n
        v-if="validCount === totalCount"
        path="bulkSend.steps.reviewData.havePassedAndAreReadyToSend"
        tag="span"
        data-test="all-rows-valid"
      >
        <template v-slot:envelopes>
          <b>{{ $t('bulkSend.steps.reviewData.allOfYourEnvelopes') }}</b>
        </template>
      </i18n>
      <i18n
        v-else
        path="bulkSend.steps.reviewData.validRows"
        tag="span"
        data-test="some-rows-valid"
      >
        <template v-slot:count>
          <b>{{ $t('bulkSend.steps.reviewData.rowCount', {count: validCount, total: totalCount}) }}</b>
        </template>
      </i18n>
  </span>
</template>

<script>
export default {
  name: 'ValidBulkSendRowsTitle',
  props: {
    totalCount: {
      required: true,
      type: Number,
    },
    validCount: {
      required: true,
      type: Number,
    },
  },
};
</script>

<style scoped>

</style>
